// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iframes {\n  width: 100%;\n  height: 100%;\n  min-height: 600px;\n  overflow: hidden;\n}\n#app {\n  overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
